import AiAlerts from './AiAlerts.vue';
import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/lumerai-alerts'),
    name: 'lumerai_alerts',
    meta: {
      permissions: ['administrator', 'agent'],
      module: 'alerts',
    },
    component: AiAlerts,
  },
];
